<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_reports'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button
                v-b-modal.new-chartsofaccount
                size="sm"
                variant="primary"
                ><i class="mdi mdi-plus"></i> New Account</b-button
              >
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy
                  ><div class="text-center text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(added_by)="data">
                  {{ data.item.added_by.username }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button
                      @click="
                        edit(
                          data.item.id,
                          data.item.account_name,
                          data.item.account_type,
                          data.item.account_subtype,
                          data.item.balance,
                        )
                      "
                      type="button"
                      class="btn-sm btn"
                      variant="primary"
                      v-b-modal.edit
                    >
                      <i class="fas fa-edit"></i>
                    </b-button>
                    <b-button
                      @click="remove(data.item.id, data.item.account_name)"
                      type="button"
                      class="btn-sm btn"
                      variant="danger"
                      v-b-modal.delete
                    >
                      <i class="mdi mdi-trash-can"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="List"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-chartsofaccount"
        centered
        title="New Account"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addChartsOfAccount">
          <div class="form-group mb-2">
            <label>Amount Name</label>
            <input v-model="account_name" type="text" class="form-control" />
            <label>Account Type</label>
            <multiselect
              v-model="account_type"
              @input="FindType"
              :options="accounttypes"
            ></multiselect>
            <div v-show="accountsubtypes.length > 0">
              <label>Account Sub Type</label>
              <multiselect
                v-model="account_subtype"
                :options="accountsubtypes"
              ></multiselect>
            </div>
            <label>Current Balance</label>
            <input v-model="balance" type="number" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-chartsofaccount')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-chartsofaccount"
        centered
        title="Edit Account"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="editChartsOfAccount">
          <div class="form-group mb-2">
            <label>Amount Name</label>
            <input v-model="account_name" type="text" class="form-control" />
            <label>Account Type</label>
            <multiselect
              v-model="account_type"
              @input="FindType"
              :options="accounttypes"
            ></multiselect>
            <div v-show="accountsubtypes.length > 0">
              <label>Account Sub Type</label>
              <multiselect
                v-model="account_subtype"
                :options="accountsubtypes"
              ></multiselect>
            </div>
            <label>Current Balance</label>
            <input v-model="balance" type="number" class="form-control" />
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-chartsofaccount')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-chartsofaccount"
        centered
        title="Delete an Account"
        title-class="font-12"
        hide-footer
      >
        <form @submit.prevent="removeChartsOfAccount">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Account :
          <b>{{ account_name }}</b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-chartsofaccount')"
              >Cancel</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  chartsofaccountMethods,
  chartsofaccountComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Charts Of Account",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      title: "Charts Of Account",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Charts Of Account", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "account_name", label: "Account Name", visible: true },
        { key: "account_type", label: "Account Type", visible: true },
        { key: "account_subtype", label: "Account Sub Type", visible: true },
        { key: "added_by", label: "Added by", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      account_name: "",
      id: "",
      account_type: "",
      account_subtype: "",
      balance: "",
      accounttypes: ["Assets", "Liability", "Equity", "Revenue", "Expense"],
      accountsubtypes: [],
    };
  },
  computed: {
    ...chartsofaccountComputed,
    List() {
      return this.chartsofaccounts.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.chartsofaccounts.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.chartsofaccounts.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchChartsOfAccounts();
    this.TotalRows = this.chartsofaccounts.length;
    this.isBusy = false;
  },
  methods: {
    ...chartsofaccountMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    FindType() {
      if (this.account_type == "Assets") {
        this.accountsubtypes = ["Current Asset", "Fixed Asset"];
      } else if (this.account_type == "Liability") {
        this.accountsubtypes = ["Current Liability", "Long-term Liability"];
      } else {
        this.accountsubtypes = [];
      }
    },
    edit(id, account_name, account_type, account_subtype, balance) {
      this.id = id;
      this.account_name = account_name;
      this.account_type = account_type;
      this.account_subtype = account_subtype;
      this.balance = balance;
      this.$bvModal.show("edit-chartsofaccount");
    },
    remove(id, account_name) {
      this.id = id;
      this.account_name = account_name;
      this.$bvModal.show("delete-chartsofaccount");
    },
    async addChartsOfAccount() {
      let formData = new FormData();
      formData.append("account_name", this.account_name);
      formData.append("account_type", this.account_type);
      formData.append("account_subtype", this.account_subtype);
      formData.append("balance", this.balance);
      let url = "/addchartsofaccount";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchChartsOfAccounts();
          this.$bvModal.hide("new-chartsofaccount");
          this.account_name = "";
          this.account_type = "";
          this.account_subtype = "";
          this.balance = "";
        }
      });
    },
    async editChartsOfAccount() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("account_name", this.account_name);
      formData.append("account_type", this.account_type);
      formData.append("account_subtype", this.account_subtype);
      formData.append("balance", this.balance);
      let url = "/editchartsofaccount";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchChartsOfAccounts();
          this.$bvModal.hide("edit-chartsofaccount");
          this.account_name = "";
          this.account_type = "";
          this.account_subtype = "";
          this.balance = "";
        }
      });
    },
    async removeChartsOfAccount() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removechartsofaccount";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchChartsOfAccounts();
          this.$bvModal.hide("delete-chartsofaccount");
        }
      });
    },
  },
};
</script>
